import React, { useEffect } from "react";
import { useField } from "formik";
import { bool, shape } from "prop-types";

import Portal from "src/shared/components/Portal";

import { defaultPostSubmitAnswers } from "../../constants/defaultPostSubmitAnswers";
import useUserProfileQuery from "../../utilities/hooks/useUserProfileQuery";
import useReducerActions from "../../utilities/useReducerActions";
import MultiStepQuestionnaire from "../MultiStepQuestionnaire";
import BuyerAgentQuestion from "./BuyerAgentQuestion";
import FinancingQuestion from "./FinancingQuestion";
import * as S from "./styled";

const Questionnaire = ({ flags, isOnLastStep }) => {
  const { dispatchSetPostSubmitAnswers } = useReducerActions();
  const { data, error, loading } = useUserProfileQuery();
  const { is_financing_status_stale, is_has_buyer_agent_stale } =
    data?.user_profile ?? {};
  const [, { error: formError }] = useField("form_submission");

  const steps = [
    is_has_buyer_agent_stale && (
      <BuyerAgentQuestion
        key="BuyerAgentQuestion"
        isOnLastStep={isOnLastStep}
      />
    ),
    flags?.fossa_new_beth_signals_show_financing_question &&
      is_financing_status_stale && (
        <FinancingQuestion
          key="FinancingQuestion"
          isOnLastStep={isOnLastStep}
        />
      )
  ].filter(Boolean);

  const setAnswerDefaults = () => {
    const questions = {};
    steps.forEach(s => {
      Object.assign(questions, defaultPostSubmitAnswers[s.key]);
    });
    dispatchSetPostSubmitAnswers(questions);
  };

  useEffect(() => {
    if (data) {
      setAnswerDefaults();
    }
  }, [loading]);

  if (error || loading) {
    return null;
  }

  return (
    <>
      <MultiStepQuestionnaire>{steps}</MultiStepQuestionnaire>
      {formError && (
        <Portal mountPoint={document.getElementById("questionnaire-error")}>
          <S.ErrorText>{formError}</S.ErrorText>
        </Portal>
      )}
    </>
  );
};

Questionnaire.propTypes = {
  flags: shape({
    fossa_new_beth_signals_show_financing_question: bool
  }).isRequired,
  isOnLastStep: bool.isRequired
};

export default Questionnaire;
